<template>
  <iframe :src="url" width="1618" height="800" style="border: none;"></iframe>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MonitorTemplate',
  computed: {
    ...mapGetters(['serverAddress']),
    url () {
      return `http://${this.serverAddress}:15080/templates.php`
    }
  }
}
</script>
